export default function ReportsIcon({
    style,
    fill="#E8E8E8",
}){
    return <svg style={style} width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 23.5H1.25C4.42564 23.5 7 20.9256 7 17.75V14C7 12.8954 7.89543 12 9 12V12C10.1046 12 11 12.8954 11 14V20.25C11 21.2165 11.7835 22 12.75 22V22C13.7165 22 14.5 21.2165 14.5 20.25V9.75C14.5 8.50736 15.5074 7.5 16.75 7.5V7.5C17.9926 7.5 19 8.50736 19 9.75V20C19 21.1046 19.8954 22 21 22V22C22.1046 22 23 21.1046 23 20V3.25C23 2.00736 24.0074 1 25.25 1V1C26.4926 1 27.5 2.00736 27.5 3.25V22" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}